export default "__VITE_ASSET__BJWf5hjT__"